/*
 * @Author: chenkailun
 * @Date: 2024-03-20 13:11:51
 * @LastEditors: chenkailun
 * @LastEditTime: 2025-03-05 10:14:22
 * @Description: 
 * @FilePath: \solarbiolite\src\store\modules\auth.js
 */
// initial state
const state = {
	isOnline: false,
	token: null,
	user: null,
	isTokenInvalid: false,		
	flag: false,
	nameTab:null
}

// mutations
const mutations = {
	signin(state, payload) {
		this.commit('saveUser', payload)
		this.commit('saveToken', payload)
		state.isTokenInvalid = false
	},
	signout(state) {
		this.commit('clearUser')
		this.commit('clearToken')
	},
	kickout(state) {
		this.commit('clearUser')
		this.commit('clearToken')
		state.isTokenInvalid = true
	},
	saveUser(state, payload) {
		state.user = Object.assign({}, payload.user)
	},
	saveToken(state, payload) {
		state.isOnline = true
		state.token = payload.token		
	},
	clearUser(state) {
		state.user = null
	},
	clearToken(state) {
		state.isOnline = false
		state.token = null
	},
	changeFlag(state, value) {
		state.flag = value;
	},
	saveNameTab(state,value) {
		state.nameTab = value
	},
}

export default {
	// namespaced: true,
	state,
	mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/auth.js